/** A filter of an issue chart besides its date range: which issues it narrows by. */
export enum IssueChartFilterKind {
  originators = 'originators',
  process = 'process',
  sites = 'sites',
  workType = 'workType',
  impact = 'impact',
  assignee = 'assignee',
}
